import LoginLayout from '../layouts/LoginLayout';
import SignupLayout from '../layouts/SignupLayout';
import RoleSelect from '../components/RoleSelect/RoleSelect';
import LoginForm from '../components/LoginForm/LoginForm';
import SignupForm from '../components/SignupForm/SignupForm';
import LandingPage from '../pages/LandingPage/LandingPage';
import SportSelect from '../components/SportSelect/SportSelect';
import PasswordPage from '../pages/PasswordPage/PasswordPage';

export const publicRoutes = [
  {
    path: '/login',
    element: <LoginLayout />,
    children: [
      { path: 'enter-credentials', element: <LoginForm /> }
    ]
  },
  {
    path: '/signup',
    element: <SignupLayout />,
    children: [
      { path: 'select-role', element: <RoleSelect /> },
      { path: 'select-sport', element: <SportSelect /> },
      { path: 'enter-credentials', element: <SignupForm /> }
    ]
  },
  {
    path: '/forgot-password',
    element: <PasswordPage type="forgot" />
  },
  {
    path: '/reset-password/:token',
    element: <PasswordPage type="reset" />
  },
  {
    path: '/coach-setup',
    element: <PasswordPage type="coach-setup" />
  },
  {
    path: '/athlete-setup',
    element: <PasswordPage type="athlete-setup" />
  },
  {
    path: '/',
    element: <LandingPage />
  }
];